<div id="searcher">
  <form class="search-form" [formGroup]="searchForm" (ngSubmit)="search(searchForm.value.searchType)">
    <div class="input-section">
      <mat-form-field class="w-100" appearance="fill" subscriptSizing="dynamic">
        <textarea
          matInput
          [formControl]="searchForm.controls['searchTerm']"
          placeholder="{{ 'Search.SearchBarPlaceholder' | translate }}"
          rows="3"
          (keydown.enter)="$event.preventDefault(); search(searchForm.value.searchType)"
        ></textarea>
      </mat-form-field>

      <div class="mt-3 d-flex align-items-center gap-4 mt-2">
        <div class="d-flex align-items-center gap-2">
          <mat-label class="form-label mb-0 text-sm font-medium text-gray-700" style="margin-bottom: 0;">{{ 'Search.Similarity' | translate }}:</mat-label>
          <ui-select
            [formControl]="searchForm.controls['scoreOption']"
            [options]="scoreOptions"
            [compact]="true"
            (valueChange)="onScoreOptionChange($event)"
          ></ui-select>
        </div>
        <div class="d-flex align-items-center gap-2">
          <ui-checkbox 
            [checked]="searchType === 'ai_gemini'" 
            (checkedChange)="onWithResponseChange($event)"
          ></ui-checkbox>
          <span 
            class="text-sm font-medium text-gray-700 cursor-pointer" 
            style="cursor: pointer;"
            (click)="onWithResponseChange(searchType !== 'ai_gemini')"
          >
            {{ 'Search.WithResponse' | translate }}
          </span>
        </div>
      </div>

      <app-loading-button
        class="w-100 mt-3"
        [label]="'Search.Search' | translate"
        [loading]="loading"
        [disabled]="searchForm.invalid"
        [icon]="'search'"
        className="w-100"
        (clicked)="search(searchForm.value.searchType)"
      ></app-loading-button>
    </div>
  </form>

  @if (displayResults) {
    <app-search-results [editions]="editions" [finalAIResponse]="finalAIResponse" [temporaryAnswer]="temporaryAnswer" [searchType]="searchType" [loading]="loading"></app-search-results>
  }
  <div class="margin-footer"></div>
</div>
